export default __webpack_public_path__ + "static/media/databinding.490a008f.png";